import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div>
            <img 
              src="/liftgeo-logo.png" 
              alt="LiftGeo" 
              className="h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed">
              Advanced geospatial analytics and custom GIS solutions for data-driven decision making.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <div className="space-y-3">
              <a href="mailto:hello@liftgeo.com" className="flex items-center gap-3 text-gray-400 hover:text-[#33C7A9] transition-colors">
                <Mail className="h-5 w-5" />
                hello@liftgeo.com
              </a>
              <a href="tel:+15551234567" className="flex items-center gap-3 text-gray-400 hover:text-[#33C7A9] transition-colors">
                <Phone className="h-5 w-5" />
                (555) 123-4567
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin className="h-5 w-5" />
                Serving clients nationwide
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} LiftGeo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;